import { createSlice } from '@reduxjs/toolkit'
import {
  defaultPage,
  defaultSize,
  defaultSortDir,
  defaultTotalElements,
  defaultSortBy,
  defaultTotalPages,
} from '../../../constants/index'
const initialState = {
  post_copyright_content: null,
  files: [],
  get_copyright_content: [],
  pageable: {
    pageNo: defaultPage,
    pageSize: defaultSize,
    sortBy: defaultSortBy,
    sortDir: defaultSortDir,
    totalPages: defaultTotalPages,
    totalElements: defaultTotalElements,
  },
}

const contentSlice = createSlice({
  name: 'contentSlice',
  initialState: initialState,
  reducers: {
    sendCopyRightContent(state, action) {
      state.post_copyright_content = action.payload
    },
    sendFiles(state, action) {
      state.files = action.payload
    },
    getCopyRightContent(state, action) {
      state.get_copyright_content = action.payload.content
      state.pageable = {
        ...state.pageable,
        pageNo: action.payload.pageNo,
        pageSize: action.payload.pageSize,
        totalElements: action.payload.totalElements,
        totalPages: action.payload.totalPages,
      }
    },
  },
})
export default contentSlice
